<div class="background">

    <div>
        <h3 mat-dialog-title>Edit {{ data.field }} of {{ data.property }}: </h3>
    </div>

    <input #fileUpload (change)="uploadFile($event)"
           [accept]="requiredFileType"
           class="file-input" type="file">

    <div class="flex-div">
        <div></div>
        <div class="artefact">
            <button (click)="fileUpload.click()" class="upload-button" color="primary"
                    mat-mini-fab>
                <mat-icon>attach_file</mat-icon>
            </button>
            <p>{{ fileName || "No Artefact uploaded." }}</p>
        </div>
        <button (click)="deleteValue()" class="div-button" color="warn" mat-mini-fab [disabled]="fileName === ''">
            <mat-icon>delete</mat-icon>
        </button>
    </div>
    <!--    @if (fileSize > 15000000) {-->
    <!--        <h4 style="text-align: center">{{ "File too big" }}</h4>-->
    <!--    }-->

    <mat-card
            [ngClass]="{'status-edited': (editedValue$ | async) === true, 'status-failed': (editedValue$ | async) === false, 'status-not-edited': !editPressed}"
            class="edited-card">
        <p *ngIf="!editPressed">Press Save to submit your change.</p>
        @if (editPressed) {
            <p *ngIf="(editedValue$ | async) === null">Editing...</p>
            <p *ngIf="(editedValue$ | async) === true">Your Change has been made.</p>
            <p *ngIf="(editedValue$ | async) === false">Your Change could not be made.</p>
        }
    </mat-card>

    <div [align]="'end'" mat-dialog-actions>
        <button [mat-dialog-close]="false" mat-raised-button>Cancel</button>
        <button (click)="editValue()" [disabled]="fileName === data.value || editPressed"
                color="primary"
                mat-raised-button>Save
        </button>
    </div>
</div>

